import { useEffect } from 'react';
import PageLayout from '../components/PageLayout';
import ArchitectureSection from '../components/ArchitectureSection';

const Architecture = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <PageLayout title="Architecture">
      <ArchitectureSection />
    </PageLayout>
  );
};

export default Architecture;
